import { setCookie } from '@vfde-sails/utils';
import { Cookies } from '../enum';

/**
 * This function save the FF token as a cookie for 7 days
 */
export const setFFCookie = (token: string) => {
    setCookie(Cookies.FRIENDS_AND_FAMILY, {
        value: token,
        expires: 7 * 24 * 60 * 60 * 1000,
    });
};
